var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26412_23524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.0007 27.9546C56.0007 38.8651 49.5831 48.8957 39.6489 53.471C25.5828 59.8941 8.96715 53.647 2.54948 39.657C0.87913 35.9615 0 32.0901 0 28.0426C0 17.1322 6.41767 7.10157 16.3519 2.52621C23.1212 -0.553355 30.7696 -0.817326 37.7148 1.73432C44.7478 4.37394 50.2864 9.56522 53.3633 16.3403C55.2095 20.0358 56.0007 23.9952 56.0007 27.9546Z",
    fill: "#F4CD00"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_26412_23524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3189 16.5413V33.9786C42.1399 34.4836 41.9116 34.8773 41.426 35.1328C41.335 35.1809 41.0247 35.3289 40.9508 35.3289H32.436V39.4912H37.154C37.1891 39.4912 37.433 39.6302 37.4807 39.6678C37.9947 40.0751 37.8656 40.8821 37.2681 41.1248C31.1343 41.224 24.9609 41.1932 18.8211 41.1406C18.2132 40.934 18.0416 40.1164 18.5354 39.6911C18.5861 39.6475 18.8539 39.4912 18.895 39.4912H23.613V35.3289H15.0989C14.5305 35.3289 13.6846 34.3844 13.7286 33.784C13.7801 27.979 13.6346 22.1508 13.8024 16.3602C14.0247 15.717 14.5834 15.2518 15.2645 15.1895H40.7852C41.564 15.2571 42.0944 15.8184 42.3189 16.5413ZM40.6435 16.8787H15.4055V33.6404H40.6435V16.8787ZM25.2891 35.3282V39.4904H30.7613V35.3282H25.2891Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6433 16.8789H15.4053V33.6406H40.6433V16.8789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7613 35.3281H25.2891V39.4904H30.7613V35.3281Z",
    fill: "#183561"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26412_23524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_26412_23524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.6,
    height: 26,
    fill: "white",
    transform: "translate(13.7188 15.1895)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFe);
export default __webpack_public_path__ + "static/media/fe.23e0e4901b92bc7a6cd95bd1c54ec812.svg";
export { ForwardRef as ReactComponent };